import { createSlice, PayloadAction, SliceCaseReducers } from '@reduxjs/toolkit';
import { BrandRestaurant, WeborderingConfiguration } from 'services/brand/brand.type';
import { RootState } from '../store';
import { filterRestaurantById } from './selectorLibs/filterRestaurantById';

export const brandSliceName = 'brand';

export type BrandState = WeborderingConfiguration | null;

const initialState: BrandState = null;

export const brandSlice = createSlice<BrandState, SliceCaseReducers<BrandState>, string>({
    name: brandSliceName,
    initialState,
    reducers: {
        updateBrand: (state, action: PayloadAction<BrandState>) => action.payload,
    },
});

export const getBrand = (state: RootState): BrandState | null => state.brand;
export const getBrandCurrency = (state: RootState): string | undefined => getBrand(state)?.currency;
export const getWebsiteMetaTitle = (state: RootState): string | undefined =>
    getBrand(state)?.module_website_meta[0].title;

export const getRestaurant =
    (restaurantId: number | null) =>
    (state: RootState): BrandRestaurant | undefined =>
        filterRestaurantById(restaurantId, getBrand(state)?.restaurants);

export const getMenuId =
    (restaurantId: number | null) =>
    (state: RootState): number | undefined =>
        getRestaurant(restaurantId)(state)?.menus[0].menuId; // active menu is the only menu present in array

export const { updateBrand } = brandSlice.actions;
